import { Injectable } from '@angular/core';
import { TransactionSearch } from '../entities/transaction/transaction-search.model';
import { LotSearch } from '../entities/lot/lot-search.model';

@Injectable({ providedIn: 'root' })
export class InventoryContext {
    cropName: string;
    programUUID: string;
    selectedProjectId: number;
    loggedInUserId: number;

    lotsCountByUnitName: any = {};

    itemIds: any[];
    itemCount: number;

    lotSearchRequest = new LotSearch();
    lotFilters: any;
    lotHiddenColumns = {};
    transactionSearchRequest = new TransactionSearch();
    transactionFilters: any;
    transactionHiddenColumns = {};
}
